import { Epic, ActionsObservable } from 'redux-observable'
import { MiddlewareAPI, Action } from 'redux'
import { RootState } from '../types'
import {
  BUY_BOND,
  FULFILL_BONDS,
  FULFILL_LOGIN,
  FULFILL_PRICES,
  SELECT_BOND,
  VIEW_BOND_DETAILS,
} from '../constants'
import {
  BuyBondAction,
  FulfillBonds,
  updateBondTradingPane,
  viewBondDetails,
} from '../actions/bondActions'
import {
  calculateInitialBondAmount,
  findChainRate,
  BondBuyMode,
  BondConfigItem,
} from '@bdswiss/mt4-connector'
import { showError } from '../actions'
import { Observable } from 'rxjs/Observable'
import { enableTradeControls } from '../actions/commonActions'
import { LoginSuccess, Prices, TradeObject } from '@bdswiss/mt4-connector'
import { MT4Connector as Mt4Connector } from '@bdswiss/mt4-connector'
import { Mt4TraderService } from '../utils/mt4-trader-service'
import { handleClientTradeOperationError, handleServerTradeOperationError } from './TradeEpics'
import { FulfillLogin, FulfillPrices } from '../actions/mt4Actions'

const mt4: Mt4Connector = Mt4Connector.Instance
const service: Mt4TraderService = new Mt4TraderService(mt4)

export const updateBondTradingPaneEpic: Epic<any, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  action$.ofType(VIEW_BOND_DETAILS, SELECT_BOND).switchMap(action => {
    const { bondListState } = state.getState()
    const prices = mt4.assets
    const tradingAccount = { ...mt4.account }
    const { selectedBond } = bondListState
    const { currency } = selectedBond!
    let rate
    let error
    try {
      rate = findChainRate(currency, tradingAccount.currency, prices).value
    } catch (e) {
      // return [showError(e), showError(e)];
      rate = 1
      error = e
    }

    const actions: Action[] = [
      updateBondTradingPane({
        amount: calculateInitialBondAmount(tradingAccount, rate, selectedBond),
        amountInitial: 2,
        tradeOperationEnabled: true,
        rate,
        bondBuyMode: BondBuyMode.BOND_BUY_MODE_CASH,
        showBondDetailDialog: false,
      }),
    ]
    if (error) {
      actions.push(showError(error))
    }
    return Observable.from(actions)
  })

export const openBondTradeEpic: Epic<Action, RootState> = (
  action$,
  state: MiddlewareAPI<RootState>
) =>
  (action$ as ActionsObservable<BuyBondAction>).ofType(BUY_BOND).mergeMap(action => {
    const { mt4Symbol, volume } = action
    // const {stopLoss: sl, takeProfit: tp, stopLossEnabled, takeProfitEnabled} = state.getState().tradingPane[tradeType];
    try {
      return service
        .openTrade(mt4Symbol, null, volume)
        .map(({ uuid, order }: TradeObject) => enableTradeControls())
        .catch(e => handleServerTradeOperationError(e))
    } catch (e) {
      return handleClientTradeOperationError(e)
    }
  })

export const openBondByUrl: Epic<any, RootState> = (action$, state: MiddlewareAPI<RootState>) =>
  Observable.zip(
    action$.ofType(FULFILL_PRICES).map(action => (action as FulfillPrices).prices),
    action$.ofType(FULFILL_LOGIN).map(action => (action as FulfillLogin).loginSuccess),
    action$.ofType(FULFILL_BONDS).map(action => (action as FulfillBonds).bonds),
    (prices: Prices, loginSuccess: LoginSuccess, bonds: BondConfigItem[]) => bonds
  ).switchMap((bonds: BondConfigItem[]) => {
    if (state.getState().appConfig.demo) {
      const requestPath = window.location.pathname
      const match = requestPath.match(/^\/bonds\/(\w{10,15}).*/i)
      if (match) {
        const isin = match[1]
        const bondConfigItem = bonds.find(item => item.isin === isin)
        if (bondConfigItem !== undefined) {
          return Observable.of(viewBondDetails(bondConfigItem))
        }
      }
    }
    return Observable.empty()
  })
